import { useState } from 'react'
import { useAppSelector } from '../../../hooks/redux'
import { Colors } from '../../../constants/Colors'

interface Props {
    icon: string,
    onClick: Function
}

const HeaderClick = ({
        icon,
        onClick
    }: Props
) => {

    const theme = useAppSelector<string>(state => state.theme.theme)

    const [isHover, setIsHover] = useState<boolean>(false)

    const handleMouseEnter = () => {
        setIsHover(true)
    }

    const handleMouseLeave = () => {
        setIsHover(false)
    }

    return (
        <span
            onClick={() => onClick()}
            style={{
                width: '60px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: "1.5em",
                cursor: "pointer",
                color: isHover
                    ? Colors[theme ?? 'light'].activeTint
                    : Colors[theme ?? 'light'].inActiveTint,
                transition: "all 0.2s"
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <i className={icon}></i>
        </span>
    )
}

export default HeaderClick